import React, { cloneElement } from 'react';
import { Formik } from 'formik';

export default ({
  initialValues,
  validationSchema,
  children,
  handleSubmit
}) =>
  <Formik
    initialValues={initialValues}
    isInitialValid={() => validationSchema.isValidSync(initialValues)}
    validationSchema={validationSchema}
    onSubmit={(values, { setSubmitting }) => {
      handleSubmit(values).then(() => setSubmitting(false));
    }}
    render={props => cloneElement(
      {...children},
      {...props}
    )}
  />